module.exports = __webpack_public_path__ + "media/applicants/icon-food-ed556d16.png";